import { cn } from "@/lib/utils";
import { ArrowSquareLeft, ArrowSquareRight, CloseCircle } from "iconsax-reactjs";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";

interface OverlayProps {
  isShow: boolean;
  onClose?: () => void;
  onBack?: () => void;
  children: ReactNode;
  className?: string;
  audience: "child" | "adult" | "white";
  isTransparent?: boolean,
  containerClassName?: string;
  contentClassName?: string;
}

export function PageModal({
  isShow,
  onClose,
  onBack,
  children,
  audience = "child",
  isTransparent,
  containerClassName,
  contentClassName,
}: OverlayProps) {
  const intl = useIntl();
  const isArabic = intl.locale === 'ar';

  useEffect(() => {
    if (isShow) {
      const originalStyle = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isShow]);

  const iconColor = audience === "adult" ? "text-primary" : audience === "child" ? "text-primary" : "text-white";

  if (!isShow) return null;

  return (
    <main className="fixed inset-0 bg-background z-50 flex flex-col  ">
      <div className={cn("relative w-full mx-auto bg-background overflow-y-auto z-20", containerClassName ?? "max-w-xl")}>
        {(onBack || onClose) && (
          <div
            className={cn(
              "flex items-center  p-4 pt-6 h-[68px] z-20",
              isTransparent ? "absolute top-0 bg-transparent  w-full" : "relative",
              onBack ? "justify-between" : "justify-end"
            )}
          >
            {onBack && (
              <button onClick={onBack}>
                {isArabic ? (
                  <ArrowSquareRight
                    variant="Bold"
                    size={36}
                    className={iconColor}
                    strokeWidth={3.5}
                  />
                ) : (
                  <ArrowSquareLeft
                    variant="Bold"
                    size={36}
                    className={iconColor}
                    strokeWidth={3.5}
                  />
                )}
              </button>
            )}

            {onClose && (
              <button onClick={onClose}>
                <CloseCircle
                  variant="Bold"
                  size={36}
                  className={iconColor}
                  strokeWidth={3.5}
                />
              </button>
            )}
          </div>
        )}
        <section className={cn(!isTransparent && "px-7.5 h-[calc(100vh_-_68px)]", contentClassName)}>
          {children}
        </section>
      </div>
    </main>
  )
}
